"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
function setAttributeEntity(dotProp, attributeEntity, setEvent) {
    setEvent({ code: dotProp + ".code", value: attributeEntity.code });
    setEvent({ code: dotProp + ".value", value: attributeEntity.value });
}

exports.default = setAttributeEntity;